<template>
  <div>
    <media :query="{maxWidth: 992}">
      <interactive-map
          :spaces="spaces"
          @spaceHoveredChange="(event) => changeHoveredSpace(event)">

        <info-map :spaces="spaces" ref="panel"
                  :mobile="true"
                  :show-info-panel="showInfoPanel"
                  @closeCard="closeCard()"
                  @spaceHoveredChange="(event) => changeHoveredSpace(event)" />

        <svg-map class="map"/>
        <carousel-map ref="carousel" :spaces="spaces" />

      </interactive-map>
    </media>
    <media :query="{minWidth: 992}">
      <interactive-map
          :spaces="spaces"
          @spaceHoveredChange="(event) => changeHoveredSpace(event)">
        <svg-map />
        <info-map :spaces="spaces" ref="panel"
                  :show-info-panel="showInfoPanel"
                  @closeCard="closeCard()"
                  @spaceHoveredChange="(event) => changeHoveredSpace(event)"
        />
        <card-map :space="currentSpace"
                  :card-show="cardShow"
                  :space-type="spaceType"
                  @closeCard="(event) => closeCard(event)" />

      </interactive-map>
    </media>
  </div>
</template>

<script>
import InteractiveMap from './map/InteractiveMap';
import SvgMap from './map/SvgMap';
import InfoMap from './map/InfoMap';
import CardMap from './map/CardMap';
import CarouselMap from './map/CarouselMap';

export default {
  name: 'StudiosMap',
  props: {
    spaces: {
      type: Array,
      required: true
    }
  },
  components: {
    InteractiveMap,
    SvgMap,
    InfoMap,
    CardMap,
    CarouselMap
  },
  computed: {
    space() {
      return this.currentSpace;
    },
  },
  data() {
    return ({
        currentSpace: null,
        cardShow: false,
        spaceType: null,
        showInfoPanel: false,
    });
  },
  methods: {
    changeHoveredSpace(event) {
      const map = document.querySelector('#interactive-map svg');
      let groups = map.querySelectorAll('#map-blocks > g');

      this.initializeBlocks(map, event.slug, event.type)

      if(event.slug && event.type) {

        let classHover = 'is-active';

        if(event.type === 'focus') {
          classHover = 'is-focused';
        }

        if(event.slug === this.$enums.Spaces.BACKLOT) {
          let parc = map.querySelector('#map-blocks #parc'),
              accommodation = map.querySelector(`#map-blocks #accommodation-1`),
              access = map.querySelector('#map-blocks #access-accommodations');

          groups =  [parc, accommodation, access];
        }
        else if (event.slug === this.$enums.Spaces.ACCESS_ACCOMMODATIONS) {
          groups = [];
        }
        else if (event.slug.indexOf(this.$enums.Spaces.FURNITURES) > -1) {
          let furnitures = map.querySelector(`#map-blocks #${this.$enums.Spaces.FURNITURES}`),
              furnitures_top = map.querySelector(`#map-blocks #${this.$enums.Spaces.FURNITURES}-2`);
          groups = [furnitures, furnitures_top];
        }
        else if (event.slug.indexOf(this.$enums.Spaces.STUDIO) > -1){
          groups = map.querySelectorAll(`#map-blocks #${this.$enums.Spaces.STUDIO} g`);
        }

        const currentGroups = this.determineGroup(map, event, groups);

        if(currentGroups) {
          currentGroups.forEach((group) => {
            if((!group.classList.contains('is-focused') || !group.classList.contains('is-active'))) {
              group.classList.add(classHover);
            }
          });
        }

        if(event.type === 'focus') {
          let slug = event.slug;

          if(slug.indexOf(this.$enums.Spaces.STORAGE) > -1 ) {
            slug = this.$enums.Spaces.STORAGE;
          }
          else if(slug.indexOf(this.$enums.Spaces.FURNITURES) > -1 ) {
            slug = this.$enums.Spaces.FURNITURES;
          }

          this.openCard(slug)
        }
      }
    },
    determineGroup(map,event, groups) {
      if(event.target && event.target.id.indexOf(this.$enums.Spaces.BACKLOT) > -1) {
        return [event.target]
      }
      else if (event.slug.indexOf(this.$enums.Spaces.BACKLOT) > -1) {
        return groups;
      }
      else if(event.slug.indexOf(this.$enums.Spaces.FURNITURES) > -1) {
        let furnitures = [];
        for(let i = 0; i < groups.length; i++) {
          let group = groups[i];
          if (group.id.indexOf(this.$enums.Spaces.FURNITURES) > -1 ) {
            furnitures.push(group)
          }
        }
        return furnitures;
      }
      else if(event.slug.indexOf(this.$enums.Spaces.STORAGE) > -1) {
        let storages = [];
        for(let i = 0; i < groups.length; i++) {
          let group = groups[i];
          if (group.id.indexOf(this.$enums.Spaces.STORAGE) > -1 ) {
            storages.push(group)
          }
        }
        return storages;
      }
      else if (event.slug.indexOf(this.$enums.Spaces.STUDIO) > -1 ) {
        for(let g = 0; g < groups.length; g++) {
          let studio = groups[g];
          if(studio.id.indexOf(this.$enums.Spaces.STUDIO) > -1 ) {
            if(studio.contains(event.target) || studio.id === event.slug) {
              return [studio];
            }
          }
        }
      }
      else  {
        for(let i = 0; i < groups.length; i++) {
          let group = groups[i];
          if (event.slug === group.id) {
            return [group];
          }
        }
      }
    },
    initializeBlocks(map, slugCurrent, type) {
      const blocks = map.querySelectorAll('#map-blocks > g');

      if(blocks) {
        blocks.forEach((block) => {
          if('focus' === type) {
            let blockChildFocused = block.querySelector('.is-focused');

            if(!blockChildFocused && block.classList.contains('is-focused') && block.id !== slugCurrent) {
              block.classList.remove('is-focused');
            }
            else if (blockChildFocused) {
              blockChildFocused.classList.remove('is-focused');
            }
          }
          else if ('hover' === type) {
            block.classList.remove('is-active');
            let current = block.querySelectorAll('.is-active');

            if(current) {
              current.forEach((g) => {
                g.classList.remove('is-active');
              })
            }

          }
        });
      }
    },
    openCard(slug) {
      this.$refs.panel.closePanel()

      for(let i = 0; i < this.$props.spaces.length; i++) {
        let area = this.$props.spaces[i];
        this.currentSpace = area.items.find( item => slug === item.slug );

        if(this.currentSpace) {
          break;
        }
      }

      if(this.currentSpace) {
        this.cardShow = true;
        document.querySelector('.InteractiveMap svg').classList.add('m-t-80')
        document.querySelector('.Map__top').classList.add('hidden')
      }
      else {
        this.closeCard();
      }
    },
    closeCard() {
      this.currentSpace = null;
      this.cardShow = false;
      this.changeHoveredSpace({slug:null, type:'focus'})
      document.querySelector('.InteractiveMap svg').classList.remove('m-t-80')
      document.querySelector('.Map__top').classList.remove('hidden')
    }
  }
}
</script>